import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'euroSign',
})
export class EuroSign implements PipeTransform {
    transform(price: string): any {
        if (price.toString().includes('.')) {
            let priceArray = price.toString().split('.');
            priceArray[1] = priceArray[1].substring(0, 2) + ' €';
            return priceArray;
        } else {
            return price + '€';
        }
    }
}
